import styled from 'styled-components';

export const VideoStyleWrapper = styled.div`
  display: flex;
  flex-direction: ${({ $isModal }) => `${$isModal ? 'row-reverse' : 'column'}`};
  object-fit: contain;
  background-color: ${({ $isModal }) => `${$isModal ? '#222' : 'transparent'}`};
  max-height: ${({ $isModal }) => `${$isModal ? '900px' : 'none'}`};
  overflow: hidden;

  aside {
    > div:first-child {
      padding: ${({ theme }) => `${theme.sizing.small} ${theme.sizing.medium}`};
    }
    // sticky header for playlist
    ol {
      overflow: auto;
      max-height: 17.5rem;
    }
  }
`;
VideoStyleWrapper.displayName = 'VideoStyleWrapper';

export const PlaylistContainer = styled.div`
  width: ${({ $isModal }) => `${$isModal ? '60%' : '100%'}`};
  max-width: ${({ $isModal }) => ($isModal ? '320px' : '100%')};
  border-top: ${({ theme, $isModal }) =>
    `${$isModal ? '0' : '0.5rem'} solid ${theme.colours.canvas.primary.main}`};

  @media (max-width: 960px) {
    max-width: ${({ $isModal }) => ($isModal ? '250px' : '100%')};
    max-height: 490px;
  }
`;
PlaylistContainer.displayName = 'PlaylistContainer';
